import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

import { PasteEvent } from './../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
  clearOnPaste: Boolean,

  modelValue: {
    type: String,
    default: ''
  }
},
  emits: ["update:modelValue", "input"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', state: string): void
  (e: 'input', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





function onPaste(payload: ClipboardEvent) {
  const event = payload as PasteEvent<HTMLInputElement>
  const { clipboardData } = event

  event.preventDefault()

  if (clipboardData) {
    const value = clipboardData.getData('text')
    const updatedValue = props.clearOnPaste
      ? value
      : `${props.modelValue}${value.trim()}`

    emit('update:modelValue', updatedValue)
    emit('input', updatedValue)
  }
}

function onChange(event: any) {
  const { value } = event.target

  emit('update:modelValue', value)
  emit('input', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", _mergeProps({ class: "input-base" }, _ctx.$attrs, {
    value: __props.modelValue,
    onInput: onChange,
    onPaste: onPaste
  }), null, 16, _hoisted_1))
}
}

})